/*
	Relative XYZ has Y=1 for media white,
	BT.2048 says media white Y=203 (at PQ 58).
	See: https://www.itu.int/dms_pub/itu-r/opb/rep/R-REP-BT.2408-3-2019-PDF-E.pdf
*/
export const YW = 203;
